export default __webpack_public_path__ + "/dist/images/followers-active.4aa2a0f0f3594f3e0ba80f7d43ed8df2.svg";